import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, LoadingController, Segment } from 'ionic-angular';
import { DriverServiceProvider } from '../../../../providers/dvm/driver-service';

declare var google;
@Component({
  selector: 'driver-map-page',
  templateUrl: 'index.html',
  providers: [DriverServiceProvider]
})
export class DriverMapPage {
  header_data: any;
  first_center_loaded: boolean;
  icon_url: string;
  @ViewChild('map') mapElement: ElementRef;
  @ViewChild('fodel_map_text') mapElement1: ElementRef;
  map: any;
  driversList: any;
  infoWindows: any;
  merchants: any;
  markers: any;
  object: string = 'drivers';

  @ViewChild('segment') segment: Segment;
  constructor(public navCtrl: NavController, public driverService: DriverServiceProvider, public loadingCtrl: LoadingController) {
    this.header_data = { ismenu: true, ishome: false, title: "FODEL Driver Manager", parentReloadData: d => { this.ionViewDidLoad() } };
  }

  ionViewDidLoad() {
    this.loadMap();
    this.loadDriver();
  }

  loadMap() {
    this.first_center_loaded = false;
    let latLng = new google.maps.LatLng(25.120965, 55.375558);
    let mapOptions = {
      center: latLng,
      zoom: 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    }
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
  }


  loadMerchants() {
    this.merchants = [];
    let loader = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loader.present();
    this.driverService.getCollectionPoints()
      .then(data => {
        let resData: any;
        resData = data;
        if (resData.data.content.length > 0) {
          console.log(resData.data.content);
          this.object = 'merchants';
          this.addMarker(resData.data.content, this.object);
        }
      });
    loader.dismiss();
  }

  loadDriver() {
    this.driversList = [];
    let loader = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loader.present();
    this.driverService.load_driver_map()
      .then(data => {
        let resData: any;
        resData = data;
        this.object = 'drivers';
        this.addMarker(resData.data, this.object);
      });
    loader.dismiss();
  }

  showMarker(data) {
    for (var i in this.infoWindows) {
      this.infoWindows[i].close();
    }
    if (this.object == 'drivers') {
      this.map.setCenter(new google.maps.LatLng(data.lat, data.lon));
      this.infoWindows[data.uid].open(this.map, this.markers[data.uid]);
    }
    else {
      this.map.setCenter(new google.maps.LatLng(data.lat, data.lng));
      this.infoWindows[data.managerUserEntity.uid].open(this.map, this.markers[data.managerUserEntity.uid]);
    }
  }

  addMarker(datas, object) {
    this.infoWindows = [];
    this.markers = [];
    this.loadMap();
    for (let data of datas) {
      if (data.hasOwnProperty('lat')) {
        if (object === 'drivers') {
          this.driversList.push(data);
        }
        else {
          this.merchants.push(data);
        }
        this.icon_url = 'https://cdn3.iconfinder.com/data/icons/web-ui-color/128/Marker_green-48.png';
        if (data.lastPingInMins >= 30) {
          this.icon_url = 'https://cdn4.iconfinder.com/data/icons/web-ui-color/128/Marker_red-48.png';
        }
        let marker = new google.maps.Marker({
          map: this.map,
          animation: google.maps.Animation.DROP,
          position: this.genrateLatLng(data),
          label: this.generateLabel(data),
          icon: {
            labelOrigin: new google.maps.Point(11, 50),
            url: this.icon_url,
            size: new google.maps.Size(48, 48),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(11, 40),
          },
        });
        if (object === 'drivers') {
          this.markers[data.uid] = marker;
        } else {
          this.markers[data.managerUserEntity.uid] = marker;
        }
        let content = this.generateContent(data);
        this.addInfoWindow(marker, content, data);
      }
    }
  }

  genrateLatLng(data) {
    if (this.object == 'drivers') {
      return new google.maps.LatLng(data.lat, data.lon);
    }
    else {
      return new google.maps.LatLng(data.lat, data.lng);
    }
  }

  generateLabel(data) {
    let lebel: any;
    if (this.object === 'drivers') {
      lebel = {
        color: 'black',
        fontWeight: 'bold',
        text: data.firstName
      }
    } else {
      lebel = {
        color: 'black',
        fontWeight: 'bold',
        text: data.name
      }
    }
    return lebel;
  }

  generateContent(data) {
    let content
    if (this.object === 'drivers') {
      content = "<h4>" + data.firstName + "!</h4><br><b>COD: </b>" + data.cod.currency + " " + data.cod.amount + "<br><b>Parcels: </b>" + data.parcels;
    }
    else {
      console.log("mins:" + data.lastPingInMins)
      let showLastPing: string;
      let hours = data.lastPingInMins / 60;
      let day = hours / 24;
      let month = day / 30;
      if (day > 0) {
        showLastPing = Math.floor(hours / 24) + " days ago";
      }
      else if (hours > 0) {
        showLastPing = Math.floor(hours) + " hours ago"
      }
      else if (month > 0) {
        showLastPing = data.lastPingInMins + " months ago"
      }
      else {
        showLastPing = data.lastPingInMins + " mins ago"
      }
      content = "<h4>" + data.managerUserEntity.companyName + "!</h4><br><b>Name: </b>" + data.managerUserEntity.firstName
        + "<br><b>E-mail: </b>" + data.managerUserEntity.email + "<br><b>Phone: </b>" + data.managerUserEntity.phone + "<br><b>Address: </b>" + data.managerUserEntity.address
        + "<br><b>Last active: </b>" + showLastPing;
    }
    return content;
  }

  addInfoWindow(marker, content, data) {
    let infoWindow = new google.maps.InfoWindow({
      content: content
    });
    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, marker);
    });
    if (this.object === 'drivers') {
      this.infoWindows[data.uid] = infoWindow;
    }
    else {
      this.infoWindows[data.managerUserEntity.uid] = infoWindow;
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/dvm/driver/map/index.ts